import config from "../config";
import * as Sentry from "@sentry/react";
// import {Route, Router, Switch } from 'react-router-dom';
// import { createBrowserHistory } from 'history';

if (config.sentryDsn && config.sentryDsn.length > 0) {
  Sentry.init({
    dsn: config.sentryDSN,
    integrations: [
      // Sentry.reactRouterV5BrowserTracingIntegration({ history }),
    ],
    tracesSampleRate: 1.0,
  });
}